import { useMemo } from "react";
import { FormattedVerificationServiceConfiguration } from "@idw-types/data/verification-service-configuration";
import { SelectFormGroup } from "../select-form-group/select-form-group";
import { BaseSelectFormGroupProps } from "./base-select-form-group-props";
import { sortStrings } from "@utils/string-util";
import { mapRpServicesToSelectOptions } from "@utils/select-option-mapping-util";
import { resources } from "@constants/hardcoded-strings";
import { AxnRpService } from "@idw-types/data/axn-rp-service";

type VerificationServiceSelectFormGroupProps = BaseSelectFormGroupProps & {
    verificationServices: Array<FormattedVerificationServiceConfiguration> | Array<AxnRpService>
};

export const VerificationServiceSelectFormGroup = (props: VerificationServiceSelectFormGroupProps) => {
    const { verificationServices, onChange, selectedOption, idPrefix, disabled, isRequired, isSearchable, isClearable, labelWidth, useVirtualList } = props;

    const verificationServiceOptions = useMemo(() => {
        return mapRpServicesToSelectOptions(verificationServices).sort((a, b) => sortStrings(a.label, b.label));
    }, [verificationServices]);

    return (
        <SelectFormGroup
            controlId={`${idPrefix}-verification-service-select`}
            label={resources.common.inputs.service.label}
            ariaLabel={resources.common.inputs.service.label}
            automationId={`${idPrefix}-verification-service-select`}
            onChange={onChange}
            options={verificationServiceOptions}
            selectedOption={selectedOption}
            disabled={disabled}
            isRequired={isRequired}
            isSearchable={isSearchable}
            isClearable={isClearable}
            labelWidth={labelWidth}
            useVirtualList={useVirtualList}
        />
    );
};